// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": function componentNodeModulesGatsbyPluginOfflineAppShellJs() {
    return import("./../gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-aboutus-js": function componentSrcPagesAboutusJs() {
    return import("./../../src/pages/aboutus.js"
    /* webpackChunkName: "component---src-pages-aboutus-js" */
    );
  },
  "component---src-pages-contactus-js": function componentSrcPagesContactusJs() {
    return import("./../../src/pages/contactus.js"
    /* webpackChunkName: "component---src-pages-contactus-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-products-js": function componentSrcPagesProductsJs() {
    return import("./../../src/pages/products.js"
    /* webpackChunkName: "component---src-pages-products-js" */
    );
  },
  "component---src-pages-services-2-d-drafting-js": function componentSrcPagesServices2DDraftingJs() {
    return import("./../../src/pages/services/2d-drafting.js"
    /* webpackChunkName: "component---src-pages-services-2-d-drafting-js" */
    );
  },
  "component---src-pages-services-3-d-modeling-js": function componentSrcPagesServices3DModelingJs() {
    return import("./../../src/pages/services/3d-modeling.js"
    /* webpackChunkName: "component---src-pages-services-3-d-modeling-js" */
    );
  },
  "component---src-pages-services-3-d-rendering-js": function componentSrcPagesServices3DRenderingJs() {
    return import("./../../src/pages/services/3d-rendering.js"
    /* webpackChunkName: "component---src-pages-services-3-d-rendering-js" */
    );
  },
  "component---src-pages-services-cad-conversion-js": function componentSrcPagesServicesCadConversionJs() {
    return import("./../../src/pages/services/cad-conversion.js"
    /* webpackChunkName: "component---src-pages-services-cad-conversion-js" */
    );
  },
  "component---src-pages-services-js": function componentSrcPagesServicesJs() {
    return import("./../../src/pages/services.js"
    /* webpackChunkName: "component---src-pages-services-js" */
    );
  },
  "component---src-pages-services-mold-design-js": function componentSrcPagesServicesMoldDesignJs() {
    return import("./../../src/pages/services/mold-design.js"
    /* webpackChunkName: "component---src-pages-services-mold-design-js" */
    );
  },
  "component---src-pages-services-simulations-js": function componentSrcPagesServicesSimulationsJs() {
    return import("./../../src/pages/services/simulations.js"
    /* webpackChunkName: "component---src-pages-services-simulations-js" */
    );
  }
};